import wx from 'weixin-js-sdk' //微信sdk依赖
import axios from 'axios'
import {getJsSdkConfig} from '../api/index'

//要用到微信API
function getJSSDK(shareurl,dataForWeixin) {
  // 调用后台接口换取参数
  let data = {
    url: shareurl
  }
  getJsSdkConfig(data).then(res=>{
    if (res.data.code == 0) {
      wx.config({
        debug: false,
        appId: res.data.data.appid,
        nonceStr: res.data.data.noncestr,
        signature: res.data.data.signature,
        timestamp: res.data.data.timestamp,
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"] //需要调用的JS接口列表
      })
      wx.checkJsApi({
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"],
        success: function (res) {}
      });

      var shareData = {
        imgUrl: dataForWeixin.img, //分享显示的缩略图地址
        link: dataForWeixin.linkurl, //分享地址
        desc: dataForWeixin.desc, //分享描述
        title: dataForWeixin.title, //分享标题
        success: function (res) {
          //console.log('success:',res)
        }, //用户确认分享后的回调函数
        cancel: function () {
          //alert('cancel')
        }, //用户取消分享后的回调函数
        fail: () => {
          //alert('fail')
        }
      }

      wx.ready(function () {
        wx.updateTimelineShareData(shareData); //分享到朋友圈
        wx.updateAppMessageShareData(shareData); //分享给朋友
      })

      wx.error(function(result) {
        console.log(JSON.stringify(result) + "微信验证失败");
      });
    }
  })
}
export default {
  getJSSDK: getJSSDK
}



// WEBPACK FOOTER //
// ./src/utlis/shareWx.js